import React from 'react';
import {
	Needs,
	CompanyType,
	ForeignTrade,
	Income,
	InvoicesIn,
	InvoicesOut,
	Languages,
	FakeCherryProviders,
	Preferences,
	Banks,
	Industry,
	Vat,
	Taxform,
	Accounts,
} from './steps/index.js';

import HorizontalLinearStepper from './components/tracker/tracker.jsx';
import peaking1 from '../../images/peaking.png';
import peaking2 from '../../images/peaking2.png';
import peaking3 from '../../images/peaking3.png';
import peaking4 from '../../images/peaking4.png';
import rocketman from '../../images/Rocketman.png';
import blueaccountant from '../../images/BlueAccountant.png';

import Dialog from '@mui/material/Dialog';
import KnetPlusForm from '../../shared/components/knetPlusForm/knetPlus';
import axios from '../utils/axiosCompanyProxy';
import './searchFlow.scss';
import i18n from '../../utils/i18n.js';
import { withTranslation } from 'react-i18next';

//REDUX
import ACTIONS, { fetchCherryPotentialProviders } from '../../redux/action';
import { connect } from 'react-redux';
import { checkStateChange } from './data/searchFlowText';

const mapStateToProps = (state) => ({
	store: state,
	loading: state.loading,
	company_store: state.company_store,
	match_score_weights: state.match_score_weights,
	potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
	addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
	fetchCherryPotentialProviders: (companyData, msWeights) =>
		dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});
class SearchFlow extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep: 0,
			reqID: '',
			searchID: '',
			completedSteps: 0,
			kNetPlusSent: false,
			helpForm: false,
			stepData: `1 - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`,
			viewedProviders: [],

			vacatiOn: true,
		};
	}

	//force redeploy
	componentDidMount() {
		let cookie = document.cookie;
		if (!cookie.includes('reqsent')) {
			document.cookie = 'reqsent=false';
		}
	}
	componentDidUpdate(_prevProps, prevState) {
		// console.log('reqID: ', this.state.reqID);
		//console.log(this.state.reqID, 'this.state.reqID IN COMPDIDUPDATE');
		this.handleSearchUpdate(prevState.activeStep);
		if (
			this.state.completedSteps >= 12 &&
			checkStateChange(_prevProps.company_store, this.props.company_store) ===
				true
			// && this.checkServices() === true
		) {
			this.props.fetchAspPotentialProviders(
				this.props.company_store,
				this.props.match_score_weights
			);
		}
		if (
			this.state.completedSteps >= 13 &&
			this.state.reqID.length > 0 &&
			checkStateChange(_prevProps.company_store, this.props.company_store)
			// && this.checkServices() === true
		) {
			//this.setState({ reqID: '' });
			this.props.addCompanyInfo({
				id: 'selected_providers',
				data: [],
				stateObject: 'company_store',
			});
		}
	}

	handleNext = (increment = 1) => {
		//console.log(increment, typeof increment, 'INCREMENT');
		if (this.state.activeStep < 13) {
			if (this.state.searchID === '') {
				this.submitSearchData();
			}
			this.setState({
				activeStep: this.state.activeStep + increment,
			});
			if (this.state.completedSteps < this.state.activeStep) {
				this.setState({
					completedSteps: this.state.completedSteps + increment,
				});
			}
		}
		//console.log(this.props.company_store, 'KOMPANI');
		window.scrollTo(0, 0);
	};
	handleBack = (decr = 1) => {
		//console.log(decr, typeof decr, 'decrement');
		if (this.state.activeStep !== 0) {
			this.setState({ activeStep: this.state.activeStep - decr });
		}
		window.scrollTo(0, 0);
	};
	handleTracker = (step) => {
		this.setState({ activeStep: step });
	};
	handleKnetPlusContact = () => {
		this.setState({ kNetPlusSent: true });
	};
	openHelpForm = () => {
		this.setState({ helpForm: true });
	};
	closeHelpForm = () => {
		this.setState({ helpForm: false });
	};

	createRequest = (companyData) => {
		let timeOfConfirm = this.state.stepData.concat(
			` Req sent - ${new Date().toLocaleTimeString(
				i18n.t('general.countryformat'),
				{
					hour12: false,
				}
			)}`
		);
		let data = Object.assign({}, companyData);
		let ppArray = [];
		for (var i in data.potential_providers) {
			ppArray.push(data.potential_providers[i]);
		}
		data.potential_providers = ppArray;
		data.searchID = this.state.searchID;
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		if (data.incominginvoices === '') {
			data.incominginvoices = 0;
		}
		if (data.outgoinginvoices === '') {
			data.outgoinginvoices = 0;
		}

		//console.log(data, 'CHERRY REQ DATA');
		//data.lang = this.props.company_store.chosenLanguage;
		axios
			.post(`/api/request`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				//sessionStorage.setItem('reqEmail', data.email);
				//itt majd nézd már meg kérlek hogy lehet elérni az _id-t a response-ban és az 124 helyett írd be azt
				//sessionStorage.setItem('reqID', response.data.result._id);
				//console.log('AXIOS RESPONSE: ', response);
				this.setState({ reqID: response.data.result._id });
				this.props.addCompanyInfo({
					id: 'reqID',
					data: response.data.result._id,
					stateObject: 'company_store',
				});
				this.updateSearchData(timeOfConfirm);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error);
			});
	};
	updateRequest = (companyData) => {
		let data = Object.assign({}, companyData);
		if (data.potential_providers) {
			delete data.potential_providers;
		}
		if (data.noofemployees === '') {
			data.noofemployees = 0;
		}
		//console.log(data, this.state.reqID, 'DATA AND REQID IN UPDATE');
		let dataToSend = { reqData: data, reqID: this.state.reqID };
		axios
			.patch(`/api/request/addprov`, dataToSend, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	hiddenHandler = (target) => {
		this.setState({ [target]: document.getElementById[target] });
	};

	submitSearchData = () => {
		let data = this.props.company_store;
		data.step = this.state.activeStep + 1;
		data.time = this.state.stepData;
		data.returnedProviders = 0;
		data.screenWidth = `${window.innerWidth}`;
		data.lang = this.props.company_store.chosenLanguage;
		axios
			.post(`/api/search`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
				this.setState({ searchID: response.data.result._id });
				response.data.result._id &&
					this.props.addCompanyInfo({
						id: 'searchID',
						data: response.data.result._id,
						stateObject: 'company_store',
					});
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};
	updateSearchData = (time) => {
		let data = this.props.company_store;
		data.lang = this.props.company_store.chosenLanguage;
		if (!this.state.requestSent) {
			data.step = this.state.activeStep + 1;
		}
		data.time = time;
		data.reqID = this.state.reqID;
		data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
		data.priceWeight = this.props.store.match_score_weights.priceWeight;
		data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
		data.experienceWeight =
			this.props.store.match_score_weights.experienceWeight;
		data.liabilityInsWeight =
			this.props.store.match_score_weights.liabilityInsWeight;
		data.badgeWeight = this.props.store.match_score_weights.badgeWeight;
		if (
			this.props.potential_providers !== undefined &&
			this.props.potential_providers.constructor === Object &&
			Object.keys(this.props.potential_providers).length !== 0
		) {
			data.returnedProviders = Object.keys(
				this.props.potential_providers
			).length;
			let tempArray = [];
			for (let i in this.props.potential_providers) {
				tempArray.push(this.props.potential_providers[i].companyname);
			}
			data.providers = tempArray;
		}
		axios
			.patch(`/api/search/${this.state.searchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};
	handleSearchUpdate = (prevStep) => {
		if (this.state.activeStep !== prevStep) {
			let timeString = this.state.stepData.concat(
				`, ${this.state.activeStep + 1} - ${new Date().toLocaleTimeString(
					'hu-HU',
					{
						hour12: false,
					}
				)}`
			);
			this.setState({
				stepData: timeString,
			});
			if (this.state.activeStep !== 1) {
				this.updateSearchData(timeString);
			}
		}
		if (prevStep === 'tableUpdate') {
			this.updateSearchData(this.state.stepData);
		}
	};
	updateViewedProviders = (provider) => {
		let data = {};
		let viewedProviders = this.state.viewedProviders;
		if (viewedProviders.length === 0) {
			viewedProviders.push(provider);
		}
		if (
			viewedProviders.length > 0 &&
			!viewedProviders.some((item) => item.name === provider.name)
		) {
			viewedProviders.push(provider);
		}
		data.viewedProviders = viewedProviders;
		this.setState({
			viewedProviders: viewedProviders,
		});
		axios
			.patch(`/api/search/${this.state.searchID}`, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	};

	stepperCounter = {
		0: 0,
		1: 1,
		2: 1,
		3: 1,
		4: 1,
		5: 1,
		6: 1,
		7: 2,
		8: 2,
		9: 2,
		10: 3,
		11: 3,
		12: 3,
		13: 3,
	};

	headerText = {
		0: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext1')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext1a')}</p>
			</div>
		),
		1: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		2: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		3: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		4: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		5: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		6: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext2')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext2a')}</p>
			</div>
		),
		7: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		8: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		9: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext3')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext3a')}</p>
			</div>
		),
		10: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext4')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext4a')}</p>
			</div>
		),
		11: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext4')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext4a')}</p>
			</div>
		),
		12: (
			<div>
				<p className="headerSubText">{i18n.t('searchflow.headertext4')}</p>
				<p className="headerText">{i18n.t('searchflow.headertext4a')}</p>
			</div>
		),
		13: null,
	};
	imageSource = {
		0: peaking1,
		1: peaking2,
		2: peaking2,
		3: peaking2,
		4: peaking2,
		5: peaking2,
		6: peaking2,
		7: peaking3,
		8: peaking3,
		9: peaking3,
		10: peaking4,
		11: peaking4,
		12: peaking4,
		13: null,
	};

	getStepContent = (step) => {
		switch (step) {
			case 0: {
				return (
					<Needs
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}

			case 1: {
				return (
					<CompanyType
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 2: {
				return (
					<Taxform
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 3: {
				return (
					<Vat
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 4: {
				return (
					<Industry
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}

			case 5: {
				return (
					<Banks
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 6: {
				return (
					<Accounts
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			// case 8: {
			// 	return (
			// 		<Software
			// 			handleNext={this.handleNext}
			// 			handleBack={this.handleBack}
			// 			openHelpForm={this.openHelpForm}
			// 		/>
			// 	);
			// }
			case 7: {
				return (
					<ForeignTrade
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 8: {
				return (
					<Income
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 9: {
				return (
					<InvoicesIn
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 10: {
				return (
					<InvoicesOut
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}

			case 11: {
				return (
					<Languages
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
					/>
				);
			}
			case 12: {
				return (
					<Preferences
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						openHelpForm={this.openHelpForm}
						fetchCherryPotentialProviders={
							this.props.fetchCherryPotentialProviders
						}
					/>
				);
			}

			case 13: {
				return (
					<FakeCherryProviders
						handleNext={this.handleNext}
						handleBack={this.handleBack}
						createRequest={this.createRequest}
						updateRequest={this.updateRequest}
						reqID={this.state.reqID}
						openHelpForm={this.openHelpForm}
						updateViewedProviders={this.updateViewedProviders}
						handleSearchUpdate={this.handleSearchUpdate}
						discountCode={this.state.discountCode}
					/>
				);
			}
			default:
				return i18n.t('general.notfound');
		}
	};

	render() {
		return (
			<div className={'SFContainer'}>
				<Dialog
					open={this.props.company_store.idk || this.state.helpForm}
					onClose={() => {
						this.props.company_store.idk === true
							? this.props.addCompanyInfo({
									id: 'idk',
									data: false,
									stateObject: 'company_store',
							  })
							: this.setState({ helpForm: false });
					}}
					handleClose={() => {
						this.props.company_store.idk === true
							? this.props.addCompanyInfo({
									id: 'idk',
									data: false,
									stateObject: 'company_store',
							  })
							: this.setState({ helpForm: false });
					}}>
					<KnetPlusForm
						kNetPlusSent={this.state.kNetPlusSent}
						handleKnetPlusContact={this.handleKnetPlusContact}
						closeHelpForm={this.closeHelpForm}
						helpForm={this.state.helpForm}
					/>
				</Dialog>
				{this.state.activeStep !== 13 && (
					<div className="SFLeftInfoArea">
						<img src={rocketman} alt="RocketMan" className="rocketman" />
					</div>
				)}
				<div
					className={`${
						this.state.activeStep !== 13 ? 'SFContentArea' : 'SFOfferArea'
					}`}>
					{this.state.activeStep !== 13 && (
						<div className="SFContentHeader">
							<div className="stepperContainer">
								<HorizontalLinearStepper
									activeStep={this.stepperCounter[this.state.activeStep]}
								/>
							</div>
							<div>{this.headerText[this.state.activeStep]}</div>

							<div>
								<img
									className="headerImg"
									alt="header"
									src={this.imageSource[this.state.activeStep]}
								/>
							</div>
						</div>
					)}

					{this.getStepContent(this.state.activeStep)}
				</div>
				{this.state.activeStep !== 13 && (
					<div className="SFRightInfoArea">
						<img
							src={blueaccountant}
							alt="Accountant lady"
							className="blueaccountant"
						/>
					</div>
				)}
				<div style={{ display: 'none' }}>
					<p>Hidden fields</p>
					<input type="hidden" />
					<br />
					<input
						type="text"
						id="utm_source"
						name="utm_source"
						// onChange={this.hiddenHandler}
						// value={this.state.utm_source}
					/>
					<br />
					<input
						type="text"
						id="utm_medium"
						name="utm_medium"
						// onChange={this.hiddenHandler}
						// value={this.state.utm_medium}
					/>
					<br />
					<input
						type="text"
						id="utm_campaign"
						name="utm_campaign"
						// onChange={this.hiddenHandler}
						// value={this.state.utm_campaign}
					/>
					<br />
					<input
						type="text"
						id="utm_content"
						name="utm_content"
						// onChange={this.hiddenHandler}
						// value={this.state.utm_content}
					/>
					<br />
					<input
						type="text"
						id="utm_term"
						name="utm_term"
						// onChange={this.hiddenHandler}
						// value={this.state.utm_term}
					/>
					<br />
					<input
						type="text"
						id="gclid"
						name="gclid"
						// onChange={this.hiddenHandler}
						// value={this.state.gclid}
					/>
					<br />
					<input
						type="text"
						id="dclid"
						name="dclid"
						// onChange={this.hiddenHandler}
						// value={this.state.dclid}
					/>
					<br />
				</div>
			</div>
		);
	}
}

export default withTranslation()(
	connect(mapStateToProps, mapDispatchToProps)(SearchFlow)
);
